<template>
  <div>
    <div class="base-page" v-if="platform == 'pc'">
      <div
        class="pc"
        v-for="field in formList"
        :key="field.fieldName + '_' + (field._i18nVersion || 0)"
      >
        <sk-select
          v-if="field.displayType == 4"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-radio
          v-if="field.displayType == 3"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-select
          v-if="field.displayType == 6"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox
          v-if="field.displayType == 5"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-img
          v-if="field.displayType == 7"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
        />
        <sk-file
          v-if="field.displayType == 8"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
        />
        <sk-input
          v-if="field.displayType == 1 && field.fieldType !== 'POLICY'"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :sms-type="'customForm'"
          :isPassword="field.fieldName == 'password'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-input
          v-else-if="field.displayType == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :sms-type="'customForm'"
          :isPassword="field.fieldName == 'password'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-textarea
          v-if="field.displayType == 2"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-date-picker
          v-if="field.fieldType == 'DATETIME'"
          :field="field"
          :check-flag="field.checkFlag"
          :field-value.sync="field.value"
        />
        <sk-line v-if="field.fieldType === 'LINE'" />
        <sk-desc v-if="field.fieldType === 'DESC'" :field="field" />
        <sk-radio-img
          v-if="field.type == 9"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-img
          v-if="field.type == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-policy
          v-if="field.fieldType == 'POLICY'"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <div v-if="field.fieldType == 'TEXT' && field.egValue" class="eg-tips">
          {{ field.egValue }}
        </div>
      </div>
    </div>
    <div class="base-page" v-if="platform == 'wap'">
      <div
        class="wap"
        v-for="field in formList"
        :key="field.fieldName + '_' + (field._i18nVersion || 0)"
      >
        <sk-select-wap
          v-if="field.displayType == 4"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-radio-wap
          v-if="field.displayType == 3"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-select-wap
          v-if="field.displayType == 6"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-wap
          v-if="field.displayType == 5"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-img-wap
          v-if="field.displayType == 7"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
        />
        <sk-file-wap
          v-if="field.displayType == 8"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-input-wap
          v-if="field.displayType == 1 && field.fieldType !== 'POLICY'"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :sms-type="'customForm'"
          :isPassword="field.fieldName == 'password'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-input-wap
          v-else-if="field.displayType == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :sms-type="'customForm'"
          :isPassword="field.fieldName == 'password'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-textarea-wap
          v-if="field.displayType == 2"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-date-picker-wap
          v-if="field.fieldType == 'DATETIME'"
          :field="field"
          :check-flag="field.checkFlag"
          :field-value.sync="field.value"
        />
        <sk-line-wap v-if="field.fieldType === 'LINE'" />
        <sk-desc-wap v-if="field.fieldType === 'DESC'" :field="field" />
        <sk-radio-img-wap
          v-if="field.type == 9"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-img-wap
          v-if="field.type == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-policy-wap
          v-if="field.fieldType == 'POLICY'"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <div v-if="field.fieldType == 'TEXT' && field.egValue" class="eg-tips">
          {{ field.egValue }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LangManager from "@/model/lang";

export default {
  name: "baseComponent",
  data() {
    return {};
  },
  props: {
    formList: Array,
    platform: String,
    extras: Object,
  },
  mounted() {
    // 首次渲染时立即应用翻译
    this.applyI18n();
    // 订阅语言变化
    this._unsub = LangManager.onChange(() => {
      this.applyI18n();
    });
  },
  beforeDestroy() {
    if (this._unsub) this._unsub();
  },
  watch: {
    formList: {
      handler() {
        this.applyI18n();
      },
      deep: true,
    },
  },
  methods: {
    // 原地修改 formList 中每个 field 的属性（不创建新对象，保持 .sync 双向绑定）
    applyI18n() {
      const lang = LangManager.current;
      const langKey = lang.toLowerCase();
      if (!this.formList || lang === "zh_CN") return;
      // 防止重复应用：记录已应用的语言版本
      const applyKey = "_i18nApplied_" + lang;
      this.formList.forEach((field) => {
        if (!field) return;
        // 如果已经应用过当前语言的翻译，跳过（防止无限循环）
        if (field[applyKey]) return;
        const i18n = field.i18n || {};
        let changed = false;
        if (
          (i18n[lang] || i18n[langKey]) &&
          field.displayName !== (i18n[lang] || i18n[langKey])
        ) {
          field.displayName = i18n[lang] || i18n[langKey];
          if (field.aliasName !== undefined)
            field.aliasName = i18n[lang] || i18n[langKey];
          changed = true;
        }
        const privacyKey = "privacyPolicyText_" + lang;
        const privacyKeyLower = "privacyPolicyText_" + langKey;
        if (
          (i18n[privacyKey] || i18n[privacyKeyLower]) &&
          field.privacyPolicyText !==
            (i18n[privacyKey] || i18n[privacyKeyLower])
        ) {
          field.privacyPolicyText = i18n[privacyKey] || i18n[privacyKeyLower];
          field.privacyPolicyTitle = i18n[privacyKey] || i18n[privacyKeyLower];
          changed = true;
        }
        if (Array.isArray(field.listOptions)) {
          field.listOptions.forEach((opt) => {
            const oi18n = opt.i18n || {};
            const translated = oi18n[lang] || oi18n[langKey];
            if (translated) {
              opt.optionLabel = translated;
              changed = true;
            }
          });
        }
        if (Array.isArray(field.options)) {
          field.options.forEach((opt) => {
            const oi18n = opt.i18n || {};
            if (oi18n[lang] || oi18n[langKey]) {
              opt.optionLabel = oi18n[lang] || oi18n[langKey];
              changed = true;
            }
          });
        }
        // 标记已应用 + 递增版本号触发 sk-input 重建
        if (changed) {
          field[applyKey] = true;
          field._i18nVersion = (field._i18nVersion || 0) + 1;
        }
      });
    },
  },
};
</script>
